module.exports = __webpack_public_path__ + "market/static/img/start.a4de696.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/award/start.png
// module id = z7W6
// module chunks = 1